import '@/css/app.css'
import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'

import Headroom from 'headroom.js'
import collapse from '@alpinejs/collapse'
// import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'
import './base/lazyVideo.js'
import './components/offer.js'
import './components/osmo/btn-stagger.js'

import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'
const lenis = new Lenis({
    autoRaf: true,
    anchors: {
        offset: -50
    },
    prevent: (node) => {
        const classes = ['choices__list']
        return classes.some((cls) => node.classList.contains(cls))
    }
})

window.lenis = lenis

const headroom = () => {
    if (window.innerWidth < 1024) {
        const header = document.querySelector('header')
        header.classList.add('sticky')
        const headroom = new Headroom(header, {
            offset: 100,
            onTop: function () {
                document.querySelector('body').classList.add('headroom--top')
                document
                    .querySelector('body')
                    .classList.remove('headroom--not-top')
            },

            onNotTop: function () {
                document.querySelector('body').classList.remove('headroom--top')
                document
                    .querySelector('body')
                    .classList.add('headroom--not-top')
            }
        }).init()
    }
}

// App main
const main = async () => {
    headroom()
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr',
        'homeBanner',
        'testimonialSlider',
        'stickySidebar',
        'tabs',
        'scrollContact',
        'dcQuestionPrice',
        'dcQuestionMedia',
        'dcLocationSweepbright',
        'dcQuestionList'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.plugin(persist)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -50
                })
                // anchorElement.scrollIntoView({ behavior: 'smooth' })
            }, 500)
        }
    }

    setTimeout(() => {
        ScrollTrigger.refresh()
        window.dispatchEvent(new Event('resize'))
    }, 1000)
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
